import { useState, useEffect } from 'react';
import { merchantsService } from '../../../services';
import { MerchantBalance } from '../../../types';

export const useMerchantBalances = () => {
  const [balances, setBalances] = useState<MerchantBalance[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchBalances = async () => {
    try {
      setLoading(true);
      const data = await merchantsService.getAllMerchantBalances();
      setBalances(data);
      setError(null);
    } catch (err: any) {
      setError(err.message || 'Ошибка при загрузке балансов');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBalances();
  }, []);

  return { balances, loading, error, refetch: fetchBalances };
}; 